<template>
    <div v-if="!showMenu & showMenu != 'undefined'">



        <!-- Page Content -->
        <div id="page-content-wrapper">

            <div>
                  <b-button v-b-toggle.sidebar-1 class="btn-menu" style="z-index: 999;"><div class="text"> Menu <b-icon icon="chevron-double-up" class="iconMenu "></b-icon></div></b-button>
                <b-sidebar id="sidebar-1" title="" shadow sidebar-class="bg-menu" bg-variant="bg-menu"
                    text-variant="light">
                  
                    <div class="text-center">
                        <img rounded="circle"  :src="currenUser.ProfileImgUrl ? currenUser.ProfileImgUrl : '../img/user-profile.png'" alt="User image"
                            class="user-Iocn rounded circle" />
                        <p>{{currenUser ? currenUser.FirstNameEN : ''}} {{currenUser? currenUser.LastNameEN : ''}}</p>

                    </div>
                    <!-- applicant menu start -->
                    <div v-if="!currenUser.LoginInfo">
                    <div class="px-3 py-2 row">

                                  <div class="col-md-6">
                            <b-link href="#" to="/dataapp">
                                <div class="menu-item Eventbg">
                                    <b-icon icon="display-fill" class=" rounded text-center"></b-icon><br />
                                    <span class="small">Data</span>

                                </div>
                            </b-link>
                        </div>

                        
                        <div class="col-md-6">
                            <b-link href="#" to='/wallet'>
                                <div class="menu-item Walletbg">
                                    <b-icon icon="wallet2" class=" rounded text-center"></b-icon><br />
                                    <span class="small"> Wallet</span>

                                </div>
                            </b-link>
                        </div>
                    </div>

                    <div class="px-3 py-2 row">
                        <div class="col-md-6">
                            <b-link href="#" to="/Exam">
                                <div class="menu-item exambg">
                                    <b-icon icon="info-circle-fill" class=" rounded text-center" ></b-icon><br />
                                    <span class="small"> Exams</span>
                                </div>
                            </b-link>
                        </div>

                          <div class="col-md-6">
                            <b-link href="#" to="/tasks">
                                <div class="menu-item Gradesbg">
                                    <b-icon icon="star-fill" class=" rounded text-center"></b-icon><br />
                                    <span class="small"> Tasks </span>

                                </div>
                            </b-link>
                        </div>
              
                        
                    </div>

                    <div class="px-3 py-2 row">
                      <div class="col-md-6">
                            <b-link href="#" to="/Mail">
                                <div class="menu-item Schedulebg">
                                    <b-icon icon="clock" class=" rounded text-center"></b-icon><br />
                                    <span class="small"> Inbox </span>

                                </div>
                            </b-link>
                        </div>


                        <div class="col-md-6">
                            <b-link href="#" to="/Profile">
                                <div class="menu-item Resturantbg">
                                    <b-icon icon="person-fill" class=" rounded text-center"></b-icon><br />
                                    <span class="small">Profile</span>

                                </div>
                            </b-link>
                        </div>
</div>
<div class="px-3 py-2 row">
                        <div class="col-md-6">
                            <b-link  @click="openDorms" Target="_blank">
                                <!-- <a :href="surveyUrl"  class="btn btn-primary" target="_blank"> -->
                                <div class="menu-item Resturantbg">
                                    <b-icon icon="house-fill" class=" rounded text-center"></b-icon><br />
                                    <span class="small">Dorms</span>

                                </div>
                            <!-- </a> -->
                            </b-link>
                        </div>
                        <div class="col-md-6">
                            <b-link @click="handleTransportationClick" Target="_blank">
                                <div class="menu-item Resturantbg">
                                    <!-- <i class="fa fa-bus" aria-hidden="true"></i> -->
                                    <div class=" rounded text-center">
                                   <svg  xmlns="http://www.w3.org/2000/svg" width="16" height="16" fill="currentColor" class="bi bi-bus-front-fill" viewBox="0 0 16 16">
  <path d="M16 7a1 1 0 0 1-1 1v3.5c0 .818-.393 1.544-1 2v2a.5.5 0 0 1-.5.5h-2a.5.5 0 0 1-.5-.5V14H5v1.5a.5.5 0 0 1-.5.5h-2a.5.5 0 0 1-.5-.5v-2a2.5 2.5 0 0 1-1-2V8a1 1 0 0 1-1-1V5a1 1 0 0 1 1-1V2.64C1 1.452 1.845.408 3.064.268A44 44 0 0 1 8 0c2.1 0 3.792.136 4.936.268C14.155.408 15 1.452 15 2.64V4a1 1 0 0 1 1 1zM3.552 3.22A43 43 0 0 1 8 3c1.837 0 3.353.107 4.448.22a.5.5 0 0 0 .104-.994A44 44 0 0 0 8 2c-1.876 0-3.426.109-4.552.226a.5.5 0 1 0 .104.994M8 4c-1.876 0-3.426.109-4.552.226A.5.5 0 0 0 3 4.723v3.554a.5.5 0 0 0 .448.497C4.574 8.891 6.124 9 8 9s3.426-.109 4.552-.226A.5.5 0 0 0 13 8.277V4.723a.5.5 0 0 0-.448-.497A44 44 0 0 0 8 4m-3 7a1 1 0 1 0-2 0 1 1 0 0 0 2 0m8 0a1 1 0 1 0-2 0 1 1 0 0 0 2 0m-7 0a1 1 0 0 0 1 1h2a1 1 0 1 0 0-2H7a1 1 0 0 0-1 1"/>
</svg></div>
                                    <!-- <b-icon icon="faBus" class=" rounded text-center"></b-icon><br /> -->
                                    <span class="small" style="font-size: 16px;">Transportation</span>

                                </div>
                            </b-link>
                        </div>
                        
                        
                        </div>
                         </div>
                        <!-- end Applicant menu-->
                        <div v-if="currenUser.LoginInfo">
                            <div class="px-3 py-2 row" >
                        <div class="col-md-6" v-for="(menu,index) in currenUser.LoginInfo" v-bind:key="index">
                            <b-link href="#" :to="menu.ViewURL">
                                <div class="menu-item Resturantbg">
                                    <b-icon icon="person-fill" class=" rounded text-center"></b-icon><br />
                                    <span class="small">{{menu.ViewName}}</span>

                                </div>
                            </b-link>
                        </div>
                        <div class="col-md-6">
                            <b-link href="#" to="/SelectEvent">
                                <div class="menu-item Resturantbg">
                                    <b-icon icon="person-fill" class=" rounded text-center"></b-icon><br />
                                    <span class="small">Event</span>

                                </div>
                            </b-link>
                        </div>
                            <div class="col-md-6">
                                <b-link href="#" to="/Request">
                                    <div class="menu-item Resturantbg">
                                        <b-icon icon="person-fill" class=" rounded text-center"></b-icon><br />
                                        <span class="small">OnLine Request</span>

                                    </div>
                                </b-link>
                             </div>
                            </div>
                        </div>
                   

                    <hr/>
                    <div class="text-center">
                    <button class="btn btn-primary text-center"  @click.prevent="logOut"> Logout <b-icon-lock-fill></b-icon-lock-fill></button>
                    </div>

                </b-sidebar>
            </div>



        </div>
    </div>


</template>

<script>
import studentData from '../services/Applicant/ApplicantData.services';

    export default {


        components: {

        },
        data() {
            return {
               ShowMenu:true,
                     facilities: null,
                     FacilitiesAdd: null,
      surveyStatus: null,   // Store survey status if needed
      token: null,          // Store the token if needed
      errorMessage: null,   // Store error message if needed
            }
        },
        computed: {
            currenUser() {
                return this.$store.state.auth.user
            },
            showMenu(){
                 return this.$store.state.auth.Menuhide
            }

        },
        mounted() {
                 studentData.facilities(this.currenUser.UserIDSerial, "dorms").then(
        (Response) => {
          this.isLoading = false;
          this.facilities = Response.data;
          // eslint-disable-next-line no-console
          console.log(Response.data);
        },
        (error) => {
          // eslint-disable-next-line no-console
          // console.log(error.response.status);

          this.message =
            (error.response &&
              error.response.data &&
              error.response.data.Message) ||
            error.message ||
            error.toString();

          if (error.response.status == 404) this.message = "";
        
  });

             studentData.FacilitiesAdd(this.currenUser.UserIDSerial).then(
        (Response) => {
          this.isLoading = false;
          this.FacilitiesAdd = Response.data;
          // eslint-disable-next-line no-console
          console.log(Response.data);
        },
        (error) => {
          // eslint-disable-next-line no-console
          // console.log(error.response.status);

          this.message =
            (error.response &&
              error.response.data &&
              error.response.data.Message) ||
            error.message ||
            error.toString();

          if (error.response.status == 404) this.message = "";
        
  });
        this.showMenu

   
        },
        methods: {
            logOut() {
         this.$store.dispatch('auth/logout');
         this.$router.push('/login');
    },
    Menu(){
        this.showMenu
    },
    dormsUrl() {
  // console.log(surveyUrl());
  return `https://sufacilities.su.edu.eg/api_login?token=${this.facilities.token}`;
//    return `https://sufacilities.su.edu.eg/api_login?token=${this.facilities.token}`;
},

// openDorms() {
//     window.open(`https://sufacilities.su.edu.eg/api_login?type=dorms&token=${this.facilities.token}`, '_blank');
//   },

//   openTransportation() {
//     window.open(`https://sufacilities.su.edu.eg/api_login?type=transportations&token=${this.facilities.token}`, '_blank');
//   },

// NewCode
async handleTransportationClick() {
    this.isLoading = true;
    try {
      const addResponse = await studentData.FacilitiesAdd(this.currenUser.UserIDSerial);
      this.FacilitiesAdd = addResponse.data;
      console.log(addResponse.data);
      const facilitiesResponse = await studentData.facilities(this.currenUser.UserIDSerial, "dorms");
      this.facilities = facilitiesResponse.data;
      
      this.openTransportation();
    } catch (error) {
      this.message = (error.response && error.response.data && error.response.data.Message) ||
                    error.message ||
                    error.toString();
      console.log(error);
      // Modified line to avoid optional chaining
      if (error.response && error.response.status === 404) {
        this.message = "";
      }
    } finally {
      this.isLoading = false;
        const facilitiesResponse = await studentData.facilities(this.currenUser.UserIDSerial, "dorms");
      this.facilities = facilitiesResponse.data;
      
      this.openTransportation();
      this.openDorms();

    }
},
  
openTransportation() {
  if (this.facilities && this.facilities.token) {
    window.open(`https://sufacilities.su.edu.eg/api_login?type=transportations&token=${this.facilities.token}`, '_blank');
  } else {
    console.error("Token is not available");
  }
},

openDorms() {
  if (this.facilities && this.facilities.token) {
    window.open(`https://sufacilities.su.edu.eg/api_login?type=dorms&token=${this.facilities.token}`, '_blank');
  } else {
    console.error("Token is not available");
  }
},





        }
    }
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>

    .btn-menu {
        cursor: pointer;
        height: 140px !important;
        width: 40px !important;
        font-size: 18px;
        position: absolute;
        left: 0 !important; 
        background: #F2B36D;
        color: #285475;
        font-weight: bold;
        text-align: center;
    
  
            border-radius: 0px 10px 10px 0px;
    padding-top: 20px;
      

    }
    .text{
  -ms-transform: rotate(270deg); /* IE 9 */
  transform: rotate(270deg);
    }

    button[aria-expanded="true"]{
  left: 320px !important; 
    transition: all 0.5s ease 0s;
  -webkit-transition: all 0.5s ease 0s;
  position:fixed;
   
}

    button[aria-expanded="false"]{
  left: 0px !important; 
  transition: 0.37s;
   
}

.b-sidebar{
       transition: all 0.9s ease 0s !important;
  -webkit-transition: all 0.9s ease 0s !important;
}
    button.not-collapsed{
        left: 320 !important; 
    }

    .user-Iocn {
        width: 100px;
        height: 100px;
            border-radius: 50% !important;

    }

    .bg-menu {
        background-color: #144163 !important;
        color: #fff !important;
    }

    .bg-dark {
        background-color: #0080ff !important;
    }

    .menu-item {
        border-radius: 10px;
        border-bottom: 1px solid #b2b2b2;
        margin-bottom: 10px;

        /* background:url('https://picsum.photos/500/500/?image=54');*/
        padding: 15px;

        font-size: 1.5rem;
        text-align: center;
    }

    a .menu-item {
        color: #fff;
        text-decoration: none !important
    }

    .exambg {
        background: url('../assets/Exam.png');
        background-repeat: no-repeat;
        background-size: cover;
    }

    .Walletbg {
        background: url('../assets/wallet.png');
        background-repeat: no-repeat;
        background-size: cover;
    }
    .Schedulebg {
        background: url('../assets/Schedule.png');
        background-repeat: no-repeat;
        background-size: cover;
    }

    .Notificationsbg {
        background: url('../assets/Notifications.png');
        background-repeat: no-repeat;
        background-size: cover;
    }

    .Gradesbg {
        background: url('../assets/Grades.png');
        background-repeat: no-repeat;
        background-size: cover;
    }

    .Resturantbg {
        background: url('../assets/Resturant.png');
        background-repeat: no-repeat;
        background-size: cover;
    }

    .Transportationbg {
        background: url('../assets/Transportation.png');
        background-repeat: no-repeat;
            background-size: cover;
    }

    .Ticketbg {
        background: url('../assets/Ticket.png');
        background-repeat: no-repeat;
            background-size: cover;
    }

    .Resturantbg {
        background: url('../assets/Resturant.png');
        background-repeat: no-repeat;
            background-size: cover;
    }

    .Roombg {
        background: url('../assets/Room.png');
        background-repeat: no-repeat;
            background-size: cover;
    }

    .Eventbg {
        background: url('../assets/Event.png');
        background-repeat: no-repeat;
            background-size: cover;
    }

    .b-sidebar-body {
        overflow-x: hidden !important;
    }

    .smallest {
        font-size: 57%;
        font-weight: 400;
    }
.b-sidebar > .b-sidebar-body {
    overflow-x: hidden !important;
    }
@media only screen and (max-width: 700px){
    .exambg {
background-position: center !important;
border: 1px solid #eee;
    }
 .Walletbg {
background-position: center !important;
border: 1px solid #eee;
    }
     .Eventbg {
background-position: center !important;
border: 1px solid #eee;
    }
     .Schedulebg {
background-position: center !important;
border: 1px solid #eee;
    }
         .Gradesbg {
background-position: center !important;
border: 1px solid #eee;
    }
}
 .iconMenu{
         padding-right: 2px;
    position: absolute;
    left: -28px;
    top: 2px;
 }

</style>

